import { lazy } from 'react';
import { createRoute, type AnyRoute } from '@tanstack/react-router';
import { webModules } from '@nw/module-registry/web';
import { EntityPage } from './pages/EntityPage.js';

const SettingsPage = lazy(() => import('./pages/SettingsPage.js').then((m) => ({ default: m.SettingsPage })));

/**
 * Window routes shared by the main router (focused pane, reflected in the URL) and the
 * in-memory pane router (second pane in split view). Called once per router.
 */
export function windowRoutes(parent: AnyRoute): AnyRoute[] {
  const settings = createRoute({ getParentRoute: () => parent, path: '/settings', component: SettingsPage });
  const person = createRoute({
    getParentRoute: () => parent,
    path: '/people/$personId',
    component: function PersonRoute() {
      const { personId } = person.useParams() as { personId: string };
      return <EntityPage entityKey={`core:person:${personId}`} />;
    },
  });
  return [settings, person, ...webModules.flatMap((m) => m.routes(parent))];
}
